import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography }: Theme) =>
  createStyles({
    alert: {
      '& b': {
        fontWeight: 600,
      },
    },
    errorAlert: {
      marginBottom: 40,
      '& b': {
        fontWeight: 600,
      },
    },
    alarmIcon: {
      width: 15,
      height: 15,
    },
    iconFormat: {
      color: palette.deepBlue,
    },
    messageStopServer: {
      fontSize: 12,
    },
    sectionTitle: {
      margin: '60px 0 32px',
    },
    strong: {
      fontWeight: 'bold',
    },
    checkboxCell: {
      padding: '0 0 0 8px',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },

    flag: {
      display: 'block',
      textAlign: 'center',
      color: palette.blue,
      border: `1px solid ${palette.blue}`,
      borderRadius: 5,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    flagPink: {
      borderColor: palette.pink,
      color: palette.pink,
      textTransform: 'capitalize',
    },
    flagGreen: {
      borderColor: palette.green,
      color: palette.green,
      textTransform: 'capitalize',
    },

    buttonDownload: {
      margin: '16px 0 0',
    },

    buttonsCustomMargin: {
      margin: '24px 0 0',
    },
    buttons: {
      margin: '40px auto 0',

      '& .MuiButtonBase-root': {
        fontFamily: 'Roboto',
        minWidth: 112,
        padding: 8,
        margin: '0 8px',
        fontSize: 14,
        fontWeight: typography.fontWeightMedium,
        borderRadius: 4,
      },
    },
    buttonCancel: {
      border: `1px solid ${palette.gray}`,
      color: palette.gray,
    },
    buttonConfirm: {
      border: `1px solid ${palette.green}`,
      backgroundColor: palette.green,
      color: palette.white,
    },
    actions: {
      paddingBottom: 25,
    },
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
      alignItems: 'end',
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      padding: '10px 0px 5px',
    },
    superAdminSyncButton: {
      color: palette.navSuperAdminActions,
      borderColor: palette.navSuperAdminActions,
    },
    adminSyncButton: {
      color: palette.navAdminActions,
      borderColor: palette.navAdminActions,
    },
    operatorSyncButton: {
      color: palette.navOperatorActions,
      borderColor: palette.navOperatorActions,
    },
    syncButton: {
      color: palette.navCompanyContextActions,
      borderColor: palette.navCompanyContextActions,
    },
    serverTables: {
      gap: '24px',
    },
    serverType: {
      marginBottom: 16,
    },
    iconReload: {
      marginRight: 5,
    },
    statusText: {
      fontSize: 12,
    },
    divider: {
      width: '100%',
    },
    dividerWarning: {
      width: '100%',
      margin: '24px 0px',
    },
    addServerButton: {
      border: `1px solid ${palette.green}`,
      color: palette.green,
      '&:hover': {
        border: `1px solid ${palette.green}`,
        color: palette.green,
      },
    },
    stopTimeContainer: {
      display: 'flex',
      gap: '8px',
    },
    stopTimeField: {
      display: 'flex',
      alignItems: 'center',
      '& .MuiGrid-root': {
        flex: 1,
      },
    },
    alarmIconsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '16px',
    },
    extendStopTimeIcon: {
      cursor: 'pointer',
      color: palette.green,
      marginRight: 4,
    },
    cancelStopTimeIcon: {
      cursor: 'pointer',
      color: palette.red,
    },
    startButton: {
      border: `1px solid ${palette.green}`,
      color: palette.green,
    },
    stopButton: {
      border: `1px solid ${palette.error.light}`,
      color: palette.error.light,
    },
    serverActionsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
    },
    serverBottomActionsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '8px',

      '& .MuiButtonBase-root': {
        margin: 0,
      },
    },
    statusTextField: {
      '& .MuiInputLabel-root': {
        fontWeight: 500,
        color: palette.orange,
      },
      '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
          border: '1px solid rgba(0, 0, 0, 0.15)',
        },
        '&:hover fieldset': {
          border: '1px solid rgba(0, 0, 0, 0.15)',
        },
      },
      '& .MuiOutlinedInput-inputAdornedStart': { cursor: 'default' },
    },
    statusTextFieldImage: {
      '& .MuiInputLabel-root': {
        fontWeight: 500,
        color: palette.orange,
      },
      '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
          border: '1px solid rgba(0, 0, 0, 0.15)',
        },
        '&:hover fieldset': {
          border: '1px solid rgba(0, 0, 0, 0.15)',
        },
      },
      '& .MuiOutlinedInput-inputAdornedStart': { cursor: 'pointer' },
    },
    inProgressLabel: {
      '& .MuiInputLabel-root': {
        color: palette.blue,
      },
    },

    runningLabel: {
      '& .MuiInputLabel-root': {
        color: palette.green,
      },
    },
    stoppedLabel: {
      '& .MuiInputLabel-root': {
        color: palette.red,
      },
    },
    warningLabel: {
      '& .MuiInputLabel-root': {
        color: palette.darkYellow,
      },
    },
    startAdornmentImage: { marginRight: 4, cursor: 'pointer' },
    startAdornment: { marginRight: 4, cursor: 'default' },
    title: { display: 'flex', alignItems: 'center' },

    publishScheduleIcon: {
      fontSize: 20,
      color: palette.darkGreen,
    },
    publishSchedule: {
      backgroundColor: palette.superLightGreen,
      borderRadius: 25,
      padding: 4,
      marginLeft: 8,
      alignItems: 'center',
      display: 'flex',
      cursor: 'pointer',
      '&>span': {
        margin: '0',
        padding: '0',
        color: palette.darkGreen,
        fontWeight: 500,
        display: 'inline-block',
        overflow: 'hidden',
        verticalAlign: 'top',
        whiteSpace: 'nowrap',
        maxWidth: '0',
        transition: 'max-width 0.1s ease-out',
        fontFamily: 'Roboto',
        fontSize: 14,
        '&::before': { content: "''", marginLeft: '4px' },
      },
      '&:hover, &:active': {
        '&>span': {
          maxWidth: 450,
          transition: 'max-width 0.2s ease-in',
          marginRight: 4,
        },
      },
    },
    executedPublications: {
      '& .MuiOutlinedInput-input': { textAlign: 'center' },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        color: palette.deepBlue,
      },
      '& .MuiOutlinedInput-root': { color: palette.deepBlue, fontWeight: 500 },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.deepBlue,
        border: `2px solid ${palette.deepBlue}`,
      },
      '& .MuiFormControl-root': { width: '100%' },
    },
    limitTextBold: { color: palette.deepBlue },
    limitText: { fontSize: 12 },
    executedPublicationsModal: { padding: '12px 0px' },
    container: { marginTop: 24 },
    header: { marginBottom: 24 },
    icon: { height: 20 },
    circularProgress: { alignSelf: 'center', margin: 'auto' },
    gridCircularProgress: { minHeight: 122 },
    buttonsBlockServerActions: { margin: '8px 0px' },
    blockActionsDescription: { fontSize: 12 },
    iconLock: { height: 16, cursor: 'pointer' },
    alertText: { fontSize: 14 },
    alertBlock: {
      marginTop: 8,
      width: '100%',
      '& b': {
        fontWeight: 600,
      },
      '& .MuiAlert-message': { width: '100%' },
    },
    lockIcon: { fontSize: 20 },
    reasonField: {
      '& .MuiOutlinedInput-root': { height: 'auto' },
      '& .MuiOutlinedInput-multiline': { padding: 14 },
    },

    platformVersionText: {
      '& .MuiInputLabel-root': {
        fontWeight: 500,
        color: palette.blue,
      },
      '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
          border: '1px solid rgba(0, 0, 0, 0.15)',
        },
        '&:hover fieldset': {
          border: '1px solid rgba(0, 0, 0, 0.15)',
        },
      },
      '& .MuiOutlinedInput-inputAdornedStart': { cursor: 'default' },
    },
    platformVersionIcon: {
      marginRight: 9,

      '& .MuiSvgIcon-root': {
        fontSize: 15,
      },
    },
    initializingMsg: {
      '& .MuiTypography-root': {
        fontSize: 14,
      },
      gap: '8px',
      display: 'flex',
    },
  });

export const styleStatus = () =>
  createStyles({
    icon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 15,
      height: 15,
      borderRadius: '50%',
      marginRight: 5,
      color: palette.white,
    },

    blue: { backgroundColor: palette.blue },
    green: { backgroundColor: palette.green },
    orange: { backgroundColor: palette.orange },
    red: { backgroundColor: palette.red },
    gray: { backgroundColor: palette.gray },

    statusText: {
      fontSize: 12,
      color: palette.darkGray,
    },
  });

export const overrideModal = {
  content: {
    padding: 12,
    fontSize: '12px !important',
    maxHeight: 600,
    overflowX: 'auto',
  },
};

export const overrideScheduleModal = {
  content: {
    padding: 12,
    fontSize: '12px !important',
    maxHeight: 600,
    overflowX: 'auto',
    width: 1100,
  },
};

export const overrideModalBlockActions = {
  content: {
    padding: '12px 0px 12px 12px',
    fontSize: '12px !important',
    maxHeight: 470,
    overflow: 'hidden',
  },
};
